import { Control, FieldValues, FieldPath } from 'react-hook-form';
import AsyncSearchSelectRHF, {
  AsyncSearchSelectProps,
} from '@/components/asyncSelect/AsyncSearchSelectRHF.tsx';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import TourListDto from '@/features/dashboard/tours/types/TourListDto.ts';

type TourSearchSelectProps<T extends FieldValues> = Omit<
  AsyncSearchSelectProps<T, TourListDto>,
  'fetchFn' | 'toOption' | 'queryKey'
> & {
  fieldPathName: FieldPath<T>;
  control: Control<T>;
};

const TourSearchSelectRHF = <T extends FieldValues>({
  ...props
}: TourSearchSelectProps<T>) => {
  return (
    <AsyncSearchSelectRHF<T, TourListDto>
      {...props}
      queryKey={toursApiQueryKeys.all()}
      fetchFn={toursApi.getTours}
      toOption={(item) => ({
        value: item.id,
        label: item.tourName,
      })}
    />
  );
};

export default TourSearchSelectRHF;
